import { RefObject, useState } from 'react';
import { CellClickData } from '../components/timeline/MainBackground'; // Adjust path

export const useCellSelection = (viewportRef: RefObject<HTMLElement>) => {  const [selectedCell, setSelectedCell] = useState<CellClickData | null>(null);
  const [isKeyboardOpen, setKeyboardOpen] = useState(false);

  const close = () => {
    setSelectedCell(null);
    setKeyboardOpen(false);
  };

  const handleFocus = (e: React.FocusEvent) => {
    const target = e.target as HTMLElement;
    const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA';
    const isMobile = window.matchMedia('(pointer: coarse)').matches;
    
    if (isInput && isMobile) {
      setKeyboardOpen(true);
    }
  };

  const select = (data: CellClickData | null) => {
    if (!data) return;
    
    // 1. Set the state immediately
    setSelectedCell(data);
    
    setTimeout(() => {
      if (!viewportRef.current) return;
      
      const container = viewportRef.current;
      const isMobile = window.innerWidth <= 900; 

      if (isMobile) {
        // --- CONFIGURATION ---
        const viewportHeight = window.innerHeight;
        // 45% of viewport (must match your CSS for the popup)
        const popupHeight = viewportHeight * 0.45; 
        const padding = 60; 
        
        // The Y-coordinate (on screen) where the popup starts
        const popupTopEdge = viewportHeight - popupHeight;
        
        // Where the clicked cell ends (on screen)
        const cellBottomEdge = data.rect.bottom;

        // --- THE LOGIC ---
        // If the cell's bottom is "deeper" (greater) than the popup's top edge, it's covered.
        if (cellBottomEdge > popupTopEdge) {
          
          // Calculate how many pixels hidden it is
          const hiddenAmount = cellBottomEdge - popupTopEdge;
          
          // Calculate the specific pixel target to scroll to
          // CURRENT position + HIDDEN amount + PADDING
          const targetScrollTop = container.scrollTop + hiddenAmount + padding;

          container.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth'
          });
        }
      }
    }, 0); // 0ms is enough to push this to the end of the event loop
  };

  return {
    selectedCell,
    isKeyboardOpen,
    select,
    close,
    handleFocus,
    handleBlur: () => setKeyboardOpen(false)
  };
};